import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards";

export default function RealEstateInvestmentUAE() {

    return (
        <main className='main'>
            <IntroSection
                title="Real Estate Investment – UAE"
                subtitle="Secure Residency & Golden Visa Through Property Ownership"
                description="The United Arab Emirates (UAE), particularly Dubai and Abu Dhabi, has become a global hotspot for real estate investors. With its world-class infrastructure, tax benefits, and high rental yields, property investment in the UAE also provides a direct pathway to long-term residency and the Golden Visa program."
                badges={[
                    "Golden Visa Residency",
                    "Freehold Ownership",
                    "Strong Rental Yields"
                ]}
                buttonText="Request a UAE Real Estate Investment Consultation →"
                buttonLink="/quote"
                imageSrc={require("../../assets/images/real-estate/real-estate-investment-uae-hero.png")}
                imageAlt="UAE Real Estate Investment"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Invest in UAE Real Estate?"
                        blocks={[
                            {
                                items: [
                                    { title: "Residency by Investment", text: "UAE Golden Visa for property investors." },
                                    { title: "Tax Benefits", text: "No property tax, no capital gains tax, and no inheritance tax." },
                                    { title: "High Rental Yields", text: "Dubai among the highest globally (6–8% average)." },
                                    { title: "Freehold Ownership", text: "Available for foreigners in designated areas." },
                                    { title: "Stable Economy", text: "Safe, business-friendly environment." },
                                    { title: "Global Hub", text: "Strong demand from expats, tourists, and corporations." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Golden Visa via Real Estate Investment"
                        blocks={[
                            {
                                items: [
                                    { text: "Minimum Investment: AED 2 million (~USD 545,000)." },
                                    { text: "Validity: 5–10 year renewable residency." },
                                    { text: "Coverage: Includes spouse, children, and domestic staff." },
                                    { text: "Requirements: Property must be completed (off-plan also eligible if AED 2M+)." },
                                    { text: "Benefits: No local sponsor required, residency not linked to employment." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Property Ownership Rules"
                        blocks={[
                            {
                                items: [
                                    { text: "Freehold Properties – available in Dubai, Abu Dhabi, Sharjah (specific zones)." },
                                    { text: "Leasehold Options – long-term leases (30–99 years)." },
                                    { text: "Corporate Structures – properties can be held via Free Zone or offshore companies." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Best Areas for Investment"
                        blocks={[
                            {
                                title: "Dubai",
                                items: [
                                    { text: "Downtown Dubai – luxury apartments, Burj Khalifa district." },
                                    { text: "Dubai Marina & Palm Jumeirah – seafront lifestyle, strong rental market." },
                                    { text: "Business Bay – mixed-use hub for business and residential." },
                                    { text: "Jumeirah Village Circle (JVC) – affordable properties with high yields." }
                                ]
                            },
                            {
                                title: "Abu Dhabi",
                                items: [
                                    { text: "Saadiyat Island – cultural hub, premium villas." },
                                    { text: "Al Reem Island – apartments with rental demand." },
                                    { text: "Yas Island – entertainment and luxury residences." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Investment Models"
                        services={[
                            { title: "Apartments & Villas", text: "For rental yields or personal use." },
                            { title: "Hotel Apartments", text: "Hassle-free investment with managed returns." },
                            { title: "Luxury Developments", text: "Branded residences (Four Seasons, Armani)." },
                            { title: "Off-Plan Properties", text: "Flexible payment plans, high appreciation potential." }
                        ]}
                    />

                    <WhySection
                        title="Advantages of UAE Real Estate Residency"
                        blocks={[
                            {
                                items: [
                                    { title: "Residency for Family", text: "Long-term stability." },
                                    { title: "Banking & Finance Access", text: "UAE residency allows account opening." },
                                    { title: "Business Integration", text: "Combine property with UAE company setup." },
                                    { title: "Global Connectivity", text: "Central hub for Europe, Asia, and Africa." },
                                    { title: "Safe Investment", text: "Regulated by RERA (Dubai) and DLD (Dubai Land Department)." }
                                ]
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Ready to invest in UAE real estate and secure residency?"
                        description="Offshore Advisory assists with property selection, Golden Visa applications, and structuring investments through Free Zone or offshore companies."
                        buttonText="Book a UAE Real Estate Consultation Today →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the minimum property investment for UAE residency?",
        content: [
            { type: "answer", text: "AED 2M (approx. USD 545k) for Golden Visa eligibility." },
        ],
    },
    {
        question: "Can I invest in off-plan properties?",
        content: [
            { type: "answer", text: "Yes, if the total value is AED 2M+." },
        ],
    },
    {
        question: "Is there property tax in Dubai?",
        content: [
            { type: "answer", text: "No annual property tax. Only a one-time 4% transfer fee applies." },
        ],
    },
    {
        question: "Can properties be purchased under company names?",
        content: [
            { type: "answer", text: "Yes, through Free Zone or offshore entities (subject to approval)." },
        ],
    },
    {
        question: "Does UAE property investment lead to citizenship?",
        content: [
            { type: "answer", text: "No, it grants long-term residency (Golden Visa), not citizenship." },
        ],
    },
];